var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.375 6.875H8.125V0.625C8.125 0.45924 8.05915 0.300269 7.94194 0.183058C7.82473 0.065848 7.66576 0 7.5 0V0C7.33424 0 7.17527 0.065848 7.05806 0.183058C6.94085 0.300269 6.875 0.45924 6.875 0.625V6.875H0.625C0.45924 6.875 0.300269 6.94085 0.183058 7.05806C0.065848 7.17527 0 7.33424 0 7.5H0C0 7.66576 0.065848 7.82473 0.183058 7.94194C0.300269 8.05915 0.45924 8.125 0.625 8.125H6.875V14.375C6.875 14.5408 6.94085 14.6997 7.05806 14.8169C7.17527 14.9342 7.33424 15 7.5 15C7.66576 15 7.82473 14.9342 7.94194 14.8169C8.05915 14.6997 8.125 14.5408 8.125 14.375V8.125H14.375C14.5408 8.125 14.6997 8.05915 14.8169 7.94194C14.9342 7.82473 15 7.66576 15 7.5C15 7.33424 14.9342 7.17527 14.8169 7.05806C14.6997 6.94085 14.5408 6.875 14.375 6.875Z",
    fill: "#00D841"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.6b1b0539db64354ffa1297a4776baa05.svg";
export { ForwardRef as ReactComponent };